import * as React from 'react';
import { RenderLeafProps } from 'slate-react';
import { RenderLeaf, SlatePlugin } from '../types';

const EditorSlowLeafTagBase = ({ leafProps, renderLeafList, plugins, renderPlaceholder }) => {
  const localLeafProps: RenderLeafProps = { ...leafProps }; // workaround for children readonly error.
  const p = {
    ...localLeafProps,
    attributes: {
      ...localLeafProps.attributes,
      'data-slate-placeholder': true,
    },
  };
  if (localLeafProps?.text?.text?.length === 0 && renderPlaceholder && renderPlaceholder(p)) {
    return renderPlaceholder(p);
  }

  renderLeafList.forEach((renderLeaf) => {
    localLeafProps.children = renderLeaf({ ...localLeafProps });
  });

  plugins.forEach(({ renderLeaf }) => {
    if (!renderLeaf) return;
    localLeafProps.children = renderLeaf(localLeafProps, renderPlaceholder);
  });

  return <span {...localLeafProps.attributes}>{localLeafProps.children}</span>;
};

const EditorSlowLeafTag = React.memo(EditorSlowLeafTagBase, (prevProps, nextProps) => {
  // Memoize only if leafProps, renderLeafList, plugins, and renderPlaceholder are unchanged
  return (
    prevProps.leafProps === nextProps.leafProps &&
    prevProps.renderLeafList === nextProps.renderLeafList &&
    prevProps.plugins === nextProps.plugins &&
    prevProps.renderPlaceholder === nextProps.renderPlaceholder
  );
});

export const renderLeafPlugins = (
  plugins: SlatePlugin[],
  renderLeafList: RenderLeaf[],
  renderPlaceholder = () => {}
) => {
  return (leafProps: RenderLeafProps) => {
    return (
      <EditorSlowLeafTag
        renderPlaceholder={renderPlaceholder}
        renderLeafList={renderLeafList}
        plugins={plugins}
        leafProps={leafProps}
      />
    );
  };
};
